import * as React from 'react';
import Cabecalho from "../components/cabecalho";
import Sidebar from "../components/sidebar";

import "./styles.scss";

export const LayoutPrincipal = ({ children }) => (
  <div>
    <Cabecalho />
    <div id="main">
      <Sidebar />
      <div className="container">
        {children}
      </div>
    </div>
  </div>
);
